import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bag-2, luggage, buggage "><path d="M8.75195 4.75C8.75195 4.61193 8.86388 4.5 9.00195 4.5H15.002C15.14 4.5 15.252 4.61193 15.252 4.75V7H16.75V21H20.25C21.2165 21 22 20.2165 22 19.25V8.75C22 7.7835 21.2165 7 20.25 7H16.752V4.75C16.752 3.7835 15.9685 3 15.002 3H9.00195C8.03545 3 7.25195 3.7835 7.25195 4.75V7H8.75V21H15.25V7H8.75195V4.75Z" fill="currentColor"/><path d="M3.75 7H7.25V21H3.75C2.7835 21 2 20.2165 2 19.25V8.75C2 7.7835 2.7835 7 3.75 7Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBag2;
